import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../../components/Header/Header';
import { getToggleLanguage } from '../../api/shareVariable';

import {
  FormattedMessage,
  defineMessages,
  intlShape,
  injectIntl,
} from 'react-intl';

import { validateInput } from '../../api/validation';
// import { configuration } from '../../configuration';

import '../../index.css';

//Modal
import Modal from 'react-modal';
import '../../assets/stylesheet/modal.css';
import logoImg from '../../assets/images/logo.png';
// import imageSrcIdentity from '../../assets/images/identity.png';

//Action
import { setLanguage, getEmailsByUsername } from '../../actions/user';
import { Flex, Button } from 'antd';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: undefined,
      lang: 'TH',
      modalIsOpen: false,
      errorMsg: '',
      error: '',
      submiting: false,
      id: this.props.user.id,
      waiting: false,
    };
    this.onGetEmails = this.onGetEmails.bind(this)
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  
  componentDidMount() {
    const { user } = this.props;
    let url = this.getJsonFromUrl();
    // d: User ID
    if (url.d) {
      this.setState({ id: url.d }, () => {
        if (user.id === '') {
          this.onGetEmails();
        }
      });
    }
  }

  getJsonFromUrl() {
    var result = [];
    let link_page = window.location.href;
    link_page.split('&').forEach(function (part) {
      var item = part.split('=');
      if (item[0].includes('?')) {
        let temp = item[0].split('?');
        item[0] = temp[1];
        // item[0] =
      }
      result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    if (this.state.waiting === false) this.setState({ modalIsOpen: false });
  }

  setLanguage() {
    const { user } = this.props;
    let newLang = '';
    if (user.language === 'th') newLang = 'en';
    else newLang = 'th';
    this.props.setLanguage(newLang);
  }

  getTextFromDic(msg) {
    const { formatMessage } = this.props.intl;

    return formatMessage(defineMessages({ message: { id: msg } }).message);
  }

  async onGetEmails(e) {
    if (e) e.preventDefault();
    const { id } = this.state;
    const checker = validateInput(id);
    this.setState({ waiting: false });
    if (checker === true) {
      this.setState({ submiting: true });
      const response = await this.props.getEmailsByUsername(id);
      if (response.status === 'error') {
        if (response.code === 'USER001') {
          this.setState({
            error: this.getTextFromDic('app.home.error_id'),
            errorMsg: '',
          });
        } else if (response.code === 'EMAIL002') {
          this.setState({
            error: this.getTextFromDic('app.home.error_email_not_found'),
            errorMsg: '',
          });
        } else {
          this.setState({
            error: 'Something went wrong. Please try again.',
            errorMsg: '',
          });
        }
        this.openModal();
      } else {
        this.props.history.push('/email');
      }
      this.setState({ submiting: false });
    } else if (checker === 'blank') {
      this.setState({
        error: this.getTextFromDic('app.home.errorblank'),
        errorMsg: '',
      });
      this.openModal();
    }
  }

  render() {
    const { language } = this.props.user;
    return (
      <div>
        <Header
          next={
            <Button
              className="languageSwicher"
              onClick={() => this.setLanguage()}
            >
              {getToggleLanguage(language)}{' '}
            </Button>
          }
        />
        
        <Flex justify={'center'} align={'center'}>
          <div className='box'>
            <form className="form-signin" onSubmit={this.onGetEmails}>
              <div className="col-md-12 mb-5 text-center img-margin">
                <img
                  alt="Prudentail"
                  src={logoImg}
                  width="250px"
                  className="img-responsive"
                />
              </div>
              <div className="col-md-12 title">
                <FormattedMessage id="app.home.title" />
              </div>
              <div className="col-md-12 appname">
                <span className='red'>PRU</span> HR PORTAL
              </div>
              <div className="col-md-12 mb-30 subtitle">
                <FormattedMessage id="app.home.subtitle" />
              </div>

              <div className="col-md-12 mb-15 text-center text-only">
                <div className="col-md-8 offset-md-2">
                  <h2 className='left'>
                    <FormattedMessage id="app.home.labelForm" />
                  </h2>
                  <span style={{ color: 'red' }}> {this.state.errorMsg} </span>
                  <input
                    type="text"
                    className="form-control form-big LoNotSensitive"
                    placeholder="เช่น GT000833"
                    style={{ textAlign: 'center' }}
                    value={this.state.id}
                    onChange={event => this.setState({ id: event.target.value })}
                  />
                </div>
              </div>
              <div className="col-md-12 text-center text-only">
                <div className="col-md-8 offset-md-2">
                  <Button shape="round" className='bigButton' type='primary' danger disabled={this.state.submiting} loading={this.state.submiting} htmlType={'submit'}><FormattedMessage id="app.home.next" /></Button>
                  {/* <input
                    hidden
                    className="btn btn-pru btn-block submit bigButton"
                    type="submit"
                    value={this.getTextFromDic('app.home.next')}
                    disabled={this.state.submiting}
                  /> */}
                </div>
              </div>
              {/* <div className="col-md-12 text-center version">
                <div className="col-md-6 offset-md-3">
                  v. {configuration.version}{' '}
                  {configuration.mode === 'uat' && 'Mode: UAT'}
                </div>
              </div> */}
            </form>
          </div>
        </Flex>

        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          className="reactModal"
          contentLabel="Modal View"
        >
          <div className="contrainer">
            <div className="row mb-15">
              <div className="col-12 text-only" style={{ textAlign: 'center' }}>
                {this.state.error}
              </div>
            </div>
            {this.state.error === '' && (
              <div className="row">
                <div
                  className="col-12 text-only"
                  style={{ textAlign: 'center' }}
                >
                  <a href="tel:1621" className="btn btn-block submit bigButton">
                    {'modalButton'}
                  </a>
                </div>
              </div>
            )}
          </div>
        </Modal>
      </div>
    );
  }
}

Home.propTypes = {
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { user } = state;

  return {
    user,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getEmailsByUsername: id => dispatch(getEmailsByUsername(id)),
    setLanguage: newLang => dispatch(setLanguage(newLang)),
  };
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Home));
